<template>
    <div class="calc-pdf-card">
        <CalcProjectName
            class="calc-pdf-card__project-name"
            :project-name="projectName"
            @update:project-name="$emit('update:projectName', $event)"
        />

        <div class="calc-pdf-card__row">
            <div class="calc-pdf-thumb">
                <svg
                    class="calc-pdf-thumb__svg"
                    viewBox="0 0 138 76"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                >
                    <path
                        d="M 4 0 L 114 0 L 138 24 L 138 72 Q 138 76 134 76 L 4 76 Q 0 76 0 72 L 0 4 Q 0 0 4 0 Z"
                        fill="rgb(245,247,247)"
                    />
                    <path
                        d="M 114 0 L 138 24 L 117 24 Q 114 24 114 21 Z"
                        fill="rgb(217,220,220)"
                    />
                </svg>
                <span class="calc-pdf-thumb__name">{{ displayedFilename }}</span>
                <span class="calc-pdf-thumb__size">({{ downloadState === 'downloading' ? $t('§calc.step3.pdf.preparing') : $t(size) }})</span>
            </div>

            <CalcButton
                variant="download"
                :disabled="disabled"
                :class="{ 'is-complete': downloadState === 'done', 'is-disabled': disabled }"
                @click="handleClick"
            >
                <template v-if="downloadState === 'done'">
                    {{ $t('§calc.step3.pdf.cta_done') }}
                    <CalcIcon name="check" color="rgb(4,15,15)" :size="16" />
                </template>
                <template v-else-if="downloadState === 'downloading'">
                    {{ $t('§calc.step3.pdf.cta_downloading') }}
                </template>
                <template v-else>
                    {{ $t('§calc.step3.pdf.cta_idle') }}
                    <CalcIcon name="download" />
                </template>
            </CalcButton>
        </div>
    </div>
</template>

<script>
import CalcButton from './CalcButton.vue'
import CalcIcon from './CalcIcon.vue'
import CalcProjectName from './CalcProjectName.vue'

export default {
    name: 'CalcPdfCard',

    components: { CalcButton, CalcIcon, CalcProjectName },

    props: {
        filename: {
            type: String,
            default: '§calc.step3.pdf.filename',
        },
        size: {
            type: String,
            default: '§calc.step3.pdf.size',
        },
        downloadState: {
            type: String,
            default: 'idle',
            validator: (v) => ['idle', 'downloading', 'done'].includes(v),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        projectName: {
            type: String,
            default: '',
        },
    },

    emits: ['download', 'update:projectName'],

    methods: {
        handleClick() {
            if (this.disabled) return
            if (this.downloadState !== 'idle') return
            this.$emit('download')
        },
    },

    computed: {
        displayedFilename() {
            if(this.projectName.length < 2) {
                return this.$t(this.filename)
            }
            return this.projectName.endsWith('.pdf') ? this.projectName : `${this.projectName}.pdf`
        },
    }
}
</script>

<style scoped>
.calc-pdf-card {
    margin-top: 24px;
    border: 1px solid var(--calc-line);
    border-radius: 16px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: white;
}

.calc-pdf-card__project-name {
    margin: 12px 0;
}

.calc-pdf-card__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
}

.calc-pdf-thumb {
    width: 138px;
    height: 76px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
}

.calc-pdf-thumb__svg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
}

.calc-pdf-thumb__name {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    width: max-content;
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 12px;
    font-weight: 500;
    line-height: 1;
    color: var(--calc-green-deep);
    text-align: center;
}

.calc-pdf-thumb__size {
    position: absolute;
    top: calc(50% + 8px);
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    font-size: 12px;
    line-height: 1;
    color: var(--calc-ink-50);
    white-space: nowrap;
}

.calc-pdf-card :deep(.calc-btn--download.is-disabled),
.calc-pdf-card .calc-btn--download.is-disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

@media (max-width: 760px) {
    .calc-pdf-card__row {
        flex-wrap: wrap;
    }
    /* .calc-pdf-card :deep(.calc-btn--download) {
        width: 100%;
    } */
}
</style>
